import RightArrowFlat from './RightArrowFlat';

export default RightArrowFlat;